module.exports = __webpack_public_path__ + "img/logo.439fef87.webp";